import { Search } from "lucide-react";
import { Input } from "../../../../components/ui/common/input";
import SupplierFilterPanel from "./SupplierFilterPanel";

interface SupplierListToolbarProps {
  searchKey: string;
  onSearchChange: (value: string) => void;
  refetchWithFilters: (isSupplierAsUser: boolean | undefined, supplierTypes: number[], orderBy: string) => void;
}

/** Search + filter row, styled after `ProductListToolbar`. */
const SupplierListToolbar = ({ searchKey, onSearchChange, refetchWithFilters }: SupplierListToolbarProps) => {
  return (
    <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center">
      <div className="tw-relative tw-w-full sm:tw-w-72">
        <Search
          size={16}
          className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-muted-foreground"
        />
        <Input
          value={searchKey}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search supplier, contact, email"
          className="tw-pl-9"
        />
      </div>
      <SupplierFilterPanel refetchWithFilters={refetchWithFilters} />
    </div>
  );
};

export default SupplierListToolbar;
